export const TITLE_PREVIEW_QUERY = 'preview';

export function canUseTitlePreviewRoute(route) {
  return !route.meta?.public && !['media', 'player-plex', 'player-jellyfin', 'youtube-play', 'live-tv-player', 'torbox-play'].includes(route.name);
}

export function parseTitlePreview(value) {
  if (typeof value !== 'string') return null;
  const match = /^(movie|tv)-([1-9]\d{0,9})$/.exec(value);
  return match ? { key: value, mediaType: match[1], id: Number(match[2]) } : null;
}

export function samePreviewBackground(to, from) {
  if (to.path !== from.path || to.hash !== from.hash) return false;
  const normalize = (query = {}) => JSON.stringify(Object.entries(query)
    .filter(([key]) => key !== TITLE_PREVIEW_QUERY)
    .sort(([a], [b]) => a.localeCompare(b)));
  return normalize(to.query) === normalize(from.query)
    && to.query?.[TITLE_PREVIEW_QUERY] !== from.query?.[TITLE_PREVIEW_QUERY]
    && !!(parseTitlePreview(to.query?.[TITLE_PREVIEW_QUERY]) || parseTitlePreview(from.query?.[TITLE_PREVIEW_QUERY]));
}

export function pickTrailerVideoId(videos) {
  if (!Array.isArray(videos)) return null;
  const candidates = videos.filter(video => video?.site === 'YouTube'
    && /^(Trailer|Teaser)$/.test(video.type)
    && /^[A-Za-z0-9_-]{11}$/.test(video.key || ''));
  const rank = video => (video.type === 'Trailer' ? 100 : 0) + (video.official ? 10 : 0);
  candidates.sort((a, b) => rank(b) - rank(a)
    || (Date.parse(b.published_at) || 0) - (Date.parse(a.published_at) || 0));
  return candidates[0]?.key || null;
}

export function placeTitlePreview(rect, viewportWidth, viewportHeight) {
  const width = Math.max(0, Math.min(440, viewportWidth - 32));
  const height = Math.min(490, Math.max(0, viewportHeight - 32));
  const clamp = (n, min, max) => Math.max(min, Math.min(n, Math.max(min, max)));
  return {
    width,
    left: clamp(rect.left + rect.width / 2 - width / 2, 16, viewportWidth - width - 16),
    top: clamp(rect.top - 18, 16, viewportHeight - height - 16),
  };
}

export function isPlainTitleClick(event) {
  return !event.defaultPrevented && (event.button == null || event.button === 0)
    && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
